declare namespace $ {

	type $mol_list__rows_shm_dashboard_app_menu_1 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['app_menu_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_dashboard_app_menu_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_footer__version_shm_dashboard_app_menu_3 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['version_data_version'] >
		,
		ReturnType< $shm_hitalama_footer['version'] >
	>
	type $shm_hitalama_footer__date_shm_dashboard_app_menu_4 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['version_data_date'] >
		,
		ReturnType< $shm_hitalama_footer['date'] >
	>
	type $shm_hitalama_mbutton__hint_shm_dashboard_app_menu_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_mbutton['hint'] >
	>
	type $shm_hitalama_mbutton__checked_shm_dashboard_app_menu_6 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['agent_opened'] >
		,
		ReturnType< $shm_hitalama_mbutton['checked'] >
	>
	type $mol_view__sub_shm_dashboard_app_menu_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_shm_dashboard_app_menu_8 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['mentions_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_dashboard_app_menu_9 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['mentions_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_dashboard_app_menu_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_dashboard_app_menu_11 = $mol_type_enforce<
		({ 
			'section': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_dashboard_app_menu_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_dashboard_app_menu_13 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['wordstat_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_dashboard_app_menu_14 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['wordstat_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_dashboard_app_menu_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_dashboard_app_menu_16 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['mention_stats_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_dashboard_app_menu_17 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['mention_stats_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_dashboard_app_menu_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_dashboard_app_menu_19 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['agent_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_dashboard_app_menu_20 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app_menu['agent_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_dashboard_app_menu_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_dashboard_app_menu_22 = $mol_type_enforce<
		({ 
			'section': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_dashboard_app_menu_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	export class $shm_dashboard_app_menu extends $mol_page {
		tools_rows( ): readonly(any)[]
		agent_opened( next?: boolean ): boolean
		page_rows( ): readonly(any)[]
		app_menu_rows( ): readonly(any)[]
		App_menu_list( ): $mol_list
		mentions_arg( ): Record<string, any>
		mentions_current( ): boolean
		wordstat_arg( ): Record<string, any>
		wordstat_current( ): boolean
		mention_stats_arg( ): Record<string, any>
		mention_stats_current( ): boolean
		agent_arg( ): Record<string, any>
		agent_current( ): boolean
		Profile( ): $shm_ba_profile_switch
		Foot_profile_card( ): $mol_view
		version_data_version( ): string
		version_data_date( ): string
		Footer( ): $shm_hitalama_footer
		agent_enabled( ): boolean
		monitoring_only( ): boolean
		attr( ): ({ 
			'monitoring_only': ReturnType< $shm_dashboard_app_menu['monitoring_only'] >,
		})  & ReturnType< $mol_page['attr'] >
		dashboard_rows( ): readonly($mol_view)[]
		app_section( ): string
		wordstat_enabled( ): boolean
		mentions_enabled( ): boolean
		mention_stats_enabled( ): boolean
		dashboard_title_current( ): string
		title( ): string
		head( ): readonly(any)[]
		tools( ): ReturnType< $shm_dashboard_app_menu['tools_rows'] >
		Lights( ): $mol_lights_toggle
		Agent_toggle( ): $shm_hitalama_mbutton
		sub( ): ReturnType< $shm_dashboard_app_menu['page_rows'] >
		App_menu( ): $mol_view
		Mentions_link( ): $mol_link
		Settings_link( ): $mol_link
		Wordstat_link( ): $mol_link
		Mention_stats_link( ): $mol_link
		Agent_link( ): $mol_link
		Docs_link( ): $mol_link
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=menu.web.view.tree.d.ts.map